import { render, staticRenderFns } from "./addMultipleTransactionsComponent.vue?vue&type=template&id=bfce58de"
import script from "./addMultipleTransactionsComponent.vue?vue&type=script&lang=js"
export * from "./addMultipleTransactionsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports